import { Breakpoints } from '@estee/elc-base-theme';
import styled from 'styled-components';
import { IBreakpointsWidth } from '../interfaces/IBreakpoints';

interface IResponsiveGridWrapper {
    breakpoints: IBreakpointsWidth;
}

export const ResponsiveGridWrapper = styled.div<IResponsiveGridWrapper>`
    display: grid;
    grid-auto-flow: dense;
    grid-gap: 0;
    grid-template-columns: repeat(
        auto-fill,
        minmax(${({ breakpoints: { columnWidthMobile } }) => columnWidthMobile}, 1fr)
    );
    @media (min-width: ${Breakpoints.desktop}px) {
        grid-template-columns: repeat(
            auto-fill,
            minmax(${({ breakpoints: { columnWidthDesktop } }) => columnWidthDesktop}, 1fr)
        );
    }
    @media (min-width: ${Breakpoints.largeScreen}px) {
        grid-template-columns: repeat(
            auto-fill,
            minmax(${({ breakpoints: { columnWidthLargeScreen } }) => columnWidthLargeScreen}, 1fr)
        );
    }
    @media (min-width: ${Breakpoints.LargeScreen}px) {
        grid-template-columns: repeat(
            auto-fill,
            minmax(${({ breakpoints: { columnWidthExtraLargeScreen } }) => columnWidthExtraLargeScreen}, 1fr)
        );
    }
`;
